import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";

interface NotificationFormProps {
  formData: {
    name: string;
    description: string;
  };
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onSubmit: () => void;
  isPending: boolean;
  submitLabel?: string;
  disabled?: boolean;
}

const NotificationForm: React.FC<NotificationFormProps> = ({
  formData,
  onChange,
  onSubmit,
  isPending,
  submitLabel = "Send Notification",
  disabled = false,
}) => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(false);
    onSubmit();
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Group controlId="formName" className="mb-3">
        <Form.Label>Notification Title</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter title"
          name="name"
          value={formData.name}
          onChange={onChange}
          required
        />
        <Form.Control.Feedback type="invalid">
          Title is required.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="formDescription" className="mb-3">
        <Form.Label>Notification Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          placeholder="Enter description"
          name="description"
          value={formData.description}
          onChange={onChange}
          required
        />
        <Form.Control.Feedback type="invalid">
          Message is required.
        </Form.Control.Feedback>
      </Form.Group>

      <Button
        type="submit"
        disabled={disabled || isPending}
        variant="primary"
        className="w-100"
      >
        {isPending ? "Sending..." : submitLabel}
      </Button>
    </Form>
  );
};

export default NotificationForm;
